var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 120,
    viewBox: "0 0 107 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "node-logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "node-logo_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9053 37.7831C31.5247 37.7831 31.2946 38.4711 31.2946 39.3884V90.989L28.3032 93.9704C27.1527 94.8877 23.0108 94.6584 21.4 93.9704L8.28387 86.1729C7.82366 85.9436 7.82366 85.4849 7.82366 85.2556C7.90036 68.5141 7.82366 34.9827 7.82366 34.5724C7.82366 34.1138 7.82366 33.8844 8.51398 33.4257L52.2344 8.42814C53.1548 7.96947 53.8452 7.96947 54.7656 8.42814L98.0258 33.1964C98.7161 33.6551 98.9462 34.3431 98.9462 35.2604V85.4849C98.9462 86.173 98.9462 86.173 98.2559 86.6316L54.7656 111.629C53.8452 112.088 53.1548 112.088 52.2344 111.629L42.1097 105.437C41.1892 104.978 40.729 104.978 39.8086 105.437L33.3656 108.648C32.6753 109.107 32.6753 109.107 33.3656 109.565L50.3936 119.656C51.314 120.115 55.2258 120.115 56.1462 119.656L102.628 93.2824C106.08 90.989 107 88.0076 107 86.6316V34.1138C107 29.7564 104.469 27.9217 102.398 26.775L56.8366 0.86004C54.5355 -0.286686 51.7742 -0.286674 49.7032 0.86004L4.60215 26.775C1.15054 28.6096 0 31.591 0 34.1137V86.1729C0 89.6129 2.07097 91.677 4.14194 93.053L19.7892 101.768C22.0902 102.914 24.8513 102.914 26.4621 102.914H26.4624C36.403 102.914 39.5785 95.117 39.5785 91.2183V39.3884C39.5785 38.0124 38.8882 37.7831 37.5075 37.7831H32.9053Z",
    fill: "url(#paint0_linear_38_262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2903 53.1486H80.3075C79.157 53.1486 79.4239 52.6505 79.157 51.7725C76.8559 44.2045 69.9527 44.2045 65.8108 44.2045C59.828 44.2045 57.2298 45.1339 56.1462 46.0392C52.6946 48.923 54.1731 52.4273 56.1462 53.6072C57.2968 54.2952 70.643 56.5886 77.3161 57.7353C87.617 59.5053 89.2817 65.5327 89.2817 70.3487C89.2817 76.9995 85.5187 79.6624 84.4495 80.6688C80.3075 84.5676 69.9527 85.0262 64.2 85.0262C48.7828 85.0262 43.7204 76.3115 43.7204 68.5141C43.7204 67.826 44.1806 67.5967 45.1011 67.5967H50.6237C51.7742 67.5967 52.0043 68.2847 52.0043 68.9727C52.0043 74.2474 57.0667 77.2288 68.1118 77.2288C78.7888 77.2288 80.5376 72.6421 80.5376 70.3487C80.5376 65.9914 73.4043 64.9771 69.7226 64.6153C56.6525 63.3311 53.3799 61.8779 52.6946 61.634C46.2516 59.3406 45.1011 53.3779 45.1011 50.3965C45.3312 42.5991 50.6237 40.0764 53.1548 38.4711C57.0617 35.9932 64.4301 36.2105 68.572 36.407C87.671 37.3135 87.2108 50.3775 87.2108 51.7725C87.2108 52.9192 87.2108 53.1486 86.2903 53.1486Z",
    fill: "url(#paint1_linear_38_262)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_262",
    x1: 13.5763,
    y1: 9.6321,
    x2: 106.946,
    y2: 94.5692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319162,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639737,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_262",
    x1: 13.5763,
    y1: 9.6321,
    x2: 106.946,
    y2: 94.5692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319162,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639737,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeLogo);
export default __webpack_public_path__ + "static/media/node-logo.f091a43998f9acd76b84b41434c0dcfb.svg";
export { ForwardRef as ReactComponent };